import { tv } from 'tailwind-variants'

import { body1, body2, h5 } from '@ui-kit/core/typography'

export const lineListContainer = tv({
  slots: {
    container: 'flex flex-col',
    dataContainer: 'flex flex-col gap-y-2.5',
  },
})

export const lineListItem = tv({
  slots: {
    mainItem: 'flex flex-row items-center justify-between',
    label: 'flex-1',
    rightGroup: 'flex flex-shrink-0 flex-row items-center justify-end gap-x-1',
    value: 'text-right',
    subItemsList: 'gap-y-2.5 pl-2.5 pt-0',
    subItem: body2({ emphasis: 'medium' }),
  },
  variants: {
    labelVariant: {
      body2: {
        label: body2(),
        value: body2(),
      },
      h5: {
        label: h5(),
        value: h5(),
      },
    },
    isBold: {
      false: {},
    },
    isValueBold: {
      false: {},
    },
    isCrossedOut: {
      true: {
        value: 'line-through',
        label: 'line-through',
      },
    },
    isValueHighlighted: {
      true: {
        rightGroup: 'rounded p-1',
      },
    },
    isValueBody1: {
      true: {
        value: body1(),
      },
    },
  },
  compoundVariants: [
    {
      labelVariant: 'body2',
      isBold: true,
      className: {
        label: 'font-inter-semibold',
        value: 'font-inter-semibold',
      },
    },
    {
      labelVariant: 'body2',
      isValueBold: true,
      className: {
        value: 'font-inter-semibold',
      },
    },
    {
      isValueBody1: true,
      isBold: true,
      className: {
        value: 'font-inter-semibold',
      },
    },
  ],
  defaultVariants: {
    isBold: false,
    labelVariant: 'body2',
    isValueBody1: false,
  },
})
